module.exports = __webpack_public_path__ + "img/34.aebffa0.png";